import React from "react";

function BackgroundVideo() {
  return (
    <div className="video-wrapper">
      <video autoPlay loop muted playsInline>
        <source src="/assets/login-bg.mp4" type="video/mp4" />
        Trình duyệt của bạn không hỗ trợ thẻ video.
      </video>
      <div className="overlay_"></div>
    </div>
  );
}

export default BackgroundVideo;
